export const auth_user_role_en = {
  MANAGER: "Manager",
  DEVELOPER: "Developer",
  DESIGNER: "Designer",
  VIEWER: "Viewer",
};
